module.exports = __webpack_public_path__ + "static/media/OSBM03.97d3b1c6.jpg";